import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';

import ProjectStageItem from './ProjectStageItem';
import useProjectStagesFilterValues from './useProjectStagesFilterValues';
import useProjectStagesOptionsQuery from './useProjectStagesOptionsQuery';

export const ProjectStageEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useOptionsQuery: useProjectStagesOptionsQuery,
  useFilterValues: useProjectStagesFilterValues,
  itemRenderer: ProjectStageItem,
};
